<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListSale()" isJump />
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" :loading="loading">
      <template #buttons>
        <div class="flex flex-y-center">
          <el-button type="success" size="mini" @click="itemDo()">新增</el-button>
          <el-dropdown class="m-l-5">
            <el-button type="default" size="mini">
              审核<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="itemPush">
                <span class="c-blue">提交</span>
              </el-dropdown-item>
              <el-dropdown-item
                v-if="$tool.hasControl(['/checkBill/leaderDoAudit'])"
                @click.native="itemPass"
              >
                <span class="c-green">通过</span>
              </el-dropdown-item>
              <el-dropdown-item
                v-if="$tool.hasControl(['/checkBill/leaderReject'])"
                @click.native="itemReject"
              >
                <span class="c-red">拒绝</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown class="m-l-5">
            <el-button type="default" size="mini">
              开单<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="itemSk">
                <span class="c-green">开收款单</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="itemBx">
                <span class="c-green">关联报销</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="itemParchaseAdd">
                <span class="c-blue">采购申请单</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown class="m-l-5">
            <el-button type="default" size="mini">
              打印<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="itemPrintVerify"> 核算单 </el-dropdown-item>
              <el-dropdown-item @click.native="itemPrintQuote"> 报价单 </el-dropdown-item>
              <el-dropdown-item @click.native="itemPrintContract"> 销售合同 </el-dropdown-item>
              <el-dropdown-item @click.native="itemPrintOrder"> 生产订单 </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown class="m-l-5">
            <el-button type="default" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="itemDelete">
                <span class="c-red">删除</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="itemCopy">
                <span class="c-green">引用新增</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-button-group class="m-l-5">
          <el-button
            :type="filterData.status_name === '' ? 'primary' : 'default'"
            size="mini"
            icon="el-icon-folder-opened"
            @click="filterStatus('')"
          >
            全部({{
              totalObj.quan_bu_count ||
              totalObj.zan_cun_count + totalObj.dai_shen_he_count + totalObj.yi_shen_he_count
            }})
          </el-button>
          <el-button
            :type="filterData.status_name === '暂存' ? 'info' : 'default'"
            size="mini"
            icon="el-icon-tickets"
            @click="filterStatus('暂存')"
          >
            暂存({{ totalObj.zan_cun_count }})
          </el-button>
          <el-button
            :type="filterData.status_name === '待审核' ? 'warning' : 'default'"
            size="mini"
            icon="el-icon-edit-outline"
            @click="filterStatus('待审核')"
          >
            待审核({{ totalObj.dai_shen_he_count }} )
          </el-button>
          <el-button
            :type="filterData.status_name === '已审核' ? 'success' : 'default'"
            size="mini"
            icon="el-icon-document-checked"
            @click="filterStatus('已审核')"
          >
            已审核({{ totalObj.yi_shen_he_count }})
          </el-button>
        </el-button-group>
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      show-footer
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 36 - 187"
      :export-config="{ type: ['xlsx'], types: ['xlsx'] }"
      :keyboard-config="{ isArrow: true }"
      :footer-method="footerMethod"
      :merge-cells="mergeCell"
      @cell-dblclick="itemDbDo"
      @keydown="tableKeydown"
      @current-change="tableCurrentChange"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          @change="headerFilterChange"
        />
      </template>
      <template #header_daterange="{ column }">
        <c-table-header
          type="daterange"
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          :value.sync="filterData[column.field]"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_jiao_huo_ri_qi="{ row }">
        {{ row.jiao_huo_ri_qi && row.jiao_huo_ri_qi.slice(0, 10) }}
      </template>
      <template #default_bill_code="{ row }">
        <el-link type="primary" @click="itemDo(row.id)"> {{ row.bill_code }} </el-link>
      </template>
      <template #default_status_name="{ row }">
        <el-tag v-if="row.status_name === '暂存'" size="mini" type="info"> 暂存 </el-tag>
        <el-tag v-if="row.status_name === '待审核'" size="mini" type="warning"> 待审核 </el-tag>
        <el-tag v-if="row.status_name === '已审核'" size="mini" type="success"> 已审核 </el-tag>
      </template>
      <template #default_photo_list="{ row }">
        <e-upload-image v-if="row.photo_list" :list.sync="row.photo_list" disabled />
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-开收款单 -->
    <PopupSk
      v-if="isShowPopupSk"
      :show.sync="isShowPopupSk"
      :companyName="activeCompanyName"
      :billId="activeBillId"
      @success="searchListData"
    />

    <!-- 弹窗-关联报销 -->
    <PopupBx
      v-if="isShowPopupBx"
      :show.sync="isShowPopupBx"
      :billId="activeBillId"
      @success="searchListData"
    />

    <!-- 弹窗-采购申请 -->
    <PopupApplyPurchase
      v-if="isShowPopupApplyPurchase"
      :show.sync="isShowPopupApplyPurchase"
      :billId="activeBillId"
      @success="searchListData"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupSk: () => import('../../../common/popup-sk'),
    PopupBx: () => import('../../../common/popup-bx'),
    PopupApplyPurchase: () => import('../../order/list/popup-apply-purchase')
  },
  data() {
    return {
      loading: true,

      // filter
      filterData: {
        bill_id: '',
        bill_date: [this.$util.getDate().monthDay, this.$util.getDate().today],
        jiao_huo_ri_qi: [],
        bill_code: '',
        company_name: '',
        saler_name: '',
        status_name: '',
        sales_amount_total: '',
        profit_total: '',
        profit_rate_total: '',
        bill_remark: ''
      },
      sortData: {
        bill_id: 'desc'
      },

      // table
      headerFilterUrl: '/admin/gcvip/checkBill/searchHeard',
      mergeCell: [],
      tableData: [],
      tableColumn: [
        {
          fixed: 'left',
          type: 'radio',
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          isMerge: true,
          width: 40
        },
        {
          title: '销售日期',
          field: 'bill_date',
          width: 180,
          isMerge: true,
          slots: { header: 'header_daterange' }
        },
        {
          title: '交货日期',
          field: 'jiao_huo_ri_qi',
          width: 180,
          isMerge: true,
          slots: { default: 'default_jiao_huo_ri_qi', header: 'header_daterange' }
        },
        {
          title: '销售单号',
          field: 'bill_code',
          width: 100,
          isMerge: true,
          slots: { header: 'header_input', default: 'default_bill_code' }
        },
        {
          title: '客户名称',
          field: 'company_name',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '业务员',
          field: 'saler_name',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '核算单审核状态',
          field: 'status_name',
          isMerge: true,
          slots: {
            header: 'header_input',
            default: 'default_status_name'
          }
        },
        {
          title: '订单销售金额(元)',
          field: 'sales_amount_total',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '订单利润(元)',
          field: 'profit_total',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          field: 'profit_rate_total',
          title: '订单利润率(%)',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '备注',
          field: 'bill_remark',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '产品图片',
          field: 'photo_list',
          isMerge: true,
          width: 63,
          slots: { default: 'default_photo_list' }
        }
      ],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        zan_cun_count: '',
        dai_shen_he_count: '',
        yi_shen_he_count: '',
        sales_amount_total_all: '',
        profit_total_all: '',
        profit_rate_all: ''
      },

      activeCompanyName: '',
      activeBillId: null,
      isShowPopupSk: false,
      isShowPopupBx: false,
      isShowPopupApplyPurchase: false
    }
  },
  mounted() {
    this.getListData()
    this.$nextTick(() => {
      this.$refs.refTable.connect(this.$refs.refToolbar) // 手动将表格和工具栏进行关联
    })
  },
  methods: {
    // 筛选状态
    filterStatus(val) {
      this.filterData.status_name = val
      this.searchListData()
    },
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/checkBill/list',
        data: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          filterData: this.filterData,
          sortData: this.sortData
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = data.list
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
            this.totalObj.zan_cun_count = res.data.zan_cun_count
            this.totalObj.dai_shen_he_count = res.data.dai_shen_he_count
            this.totalObj.yi_shen_he_count = res.data.yi_shen_he_count
            this.totalObj.sales_amount_total_all = res.data.sales_amount_total_all
            this.totalObj.profit_total_all = res.data.profit_total_all
            this.totalObj.profit_rate_all = res.data.profit_rate_all
            this.mergeCell = this.$tool.getMergeCellConfigList(
              this.tableData,
              this.tableColumn,
              'bill_id'
            )
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'sales_amount_total') return this.totalObj.sales_amount_total_all
          if (column.field === 'profit_total') return this.totalObj.profit_total_all
          if (column.field === 'profit_rate_total') return this.totalObj.profit_rate_all
        })
      ]
    },
    // 获取-当前单选行
    getRadioRecord() {
      return this.$refs.refTable.getRadioRecord()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setRadioRow(params.row) // 选中radio
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowRadio = this.$refs.refTable.isCheckedByRadioRow(row)
        if (isCurrentRowRadio) {
          this.$refs.refTable.clearRadioRow() // 清空radio
        } else {
          this.$refs.refTable.setRadioRow(row) // 选中radio
        }
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 项-引用新增
    itemCopy() {
      let row = this.getRadioRecord()
      if (row) {
        this.itemCopyAction(row.id)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-引用新增
    itemCopyAction(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/copy',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('引用新增成功')
            this.getListData()
          }
        })
        .catch(() => {})
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.id)
    },
    // 项-增改
    itemDo(id) {
      let url = '/sale/verify/detail'
      if (id) url = `${url}?id=${id}`
      window.open(url, '_blank')
    },
    // 项-打印-核算单
    itemPrintVerify() {
      let row = this.getRadioRecord()
      if (row) {
        this.itemPrintVerifyAction(row.bill_id)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-打印-核算单-执行
    itemPrintVerifyAction(id) {
      window.open(`/sale/verify/print?id=${id}`, '_blank')
    },
    // 项-删除
    itemDelete() {
      let row = this.getRadioRecord()
      if (row) {
        this.itemDeleteAction(row)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-删除-执行
    itemDeleteAction(row) {
      this.$confirm(`销售单号：${row.bill_code}，是否删除该核算单?`, '提示')
        .then(() => {
          this.itemDeleteConfirm(row.id)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    itemDeleteConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/doDelete',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success(res.data.msg)
            this.getListData()
          }
        })
        .catch(() => {})
    },
    // 项-提交审核
    itemPush() {
      let row = this.getRadioRecord()
      if (row) {
        if (row.status !== 0) {
          this.$message.error('暂存状态的单据才能提交审核')
          return
        }
        this.itemPushConfirm(row.bill_id)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-提交审核-确认
    itemPushConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/salerDoAudit',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已提交审核')
          this.getListData()
        }
      })
    },
    // 项-审核拒绝
    itemReject() {
      let row = this.getRadioRecord()
      if (row) {
        if (row.status === 0) {
          this.$message.error('暂存状态的单据不能审核拒绝')
          return
        }
        this.itemRejectAction(row)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-审核拒绝
    itemRejectAction(row) {
      this.$confirm(`销售单号：${row.bill_code}，该核算单是否驳回审核?`, '提示')
        .then(() => {
          this.itemRejectConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-审核拒绝-确认
    itemRejectConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/leaderReject',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已驳回审核')
          this.getListData()
        }
      })
    },
    // 项-审核通过
    itemPass() {
      let row = this.getRadioRecord()
      if (row) {
        if (row.status !== 1) {
          this.$message.error('待审核状态的单据才能审核通过')
          return
        }
        this.itemPassAction(row)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-审核通过
    itemPassAction(row) {
      this.$confirm(`销售单号：${row.bill_code}，该核算单是否通过审核?`, '提示')
        .then(() => {
          this.itemPassConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-审核通过-确认
    itemPassConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/leaderDoAudit',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已通过审核')
          this.getListData()
        }
      })
    },
    // 项-打印-报价单
    itemPrintQuote() {
      let row = this.getRadioRecord()
      if (row) {
        window.open(`/sale/quote/print?id=${row.bill_id}`, '_blank')
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-打印-销售合同
    itemPrintContract() {
      let row = this.getRadioRecord()
      if (row) {
        window.open(`/sale/contract/print?id=${row.bill_id}`, '_blank')
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-打印-生产订单
    itemPrintOrder() {
      let row = this.getRadioRecord()
      if (row) {
        window.open(`/sale/order/print?id=${row.bill_id}`, '_blank')
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-开收款单
    itemSk() {
      let row = this.getRadioRecord()
      if (row) {
        this.activeCompanyName = row.company_name
        this.activeBillId = row.bill_id
        this.isShowPopupSk = true
      } else {
        this.activeBillId = null
        this.itemChoosePrompt()
      }
    },
    // 项-关联报销
    itemBx() {
      let row = this.getRadioRecord()
      if (row) {
        this.activeBillId = row.bill_id
        this.isShowPopupBx = true
      } else {
        this.activeBillId = null
        this.itemChoosePrompt()
      }
    },
    // 项-生成采购申请单
    itemParchaseAdd() {
      let row = this.getRadioRecord()
      if (row) {
        if (row.status !== 2) {
          this.$message.error('已审核状态的单据才能生成采购申请单')
          return
        }
        this.activeBillId = row.bill_id
        this.isShowPopupApplyPurchase = true
      } else {
        this.activeBillId = null
        this.itemChoosePrompt()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
